import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EventDetailsComponent from '../../components/EventDetails';
import { getSingleEvent, eventGoing, eventNotGoing, updateEventsRequest } from '../../actionCreators/events';
import {
  toggleLikeRequest,
  toggleCommentLikeRequest,
  populatePostReportTypesRequest,
  postCommentRequest,
  getFeedItemDetailsRequest
} from '../../actionCreators/feedActions';
import { addAlertToAlertsList } from '../../actionCreators/globalAlerts';

import { RESET_EVENT_BY_ID_SUCCESS } from '../../constants/actionTypes';

const EventDetails = (props) => <EventDetailsComponent {...props} />;

const EventDetailsContainer = (props) => {
  const state = useSelector((state) => ({
    communities: state.communities.communitiesList,
    currentCommunity: state.communities.currentCommunity,
    singleEvent: state.events.singleEvent,
    userImageUrl: state.currentUser.signInData.imageUrl,
    currentUser: state.currentUser,
  }));

  const dispatch = useDispatch();

  const actions = {
    addAlertToAlerts: payload => dispatch(addAlertToAlertsList(payload)),
    getEventById: (payload) => dispatch(getSingleEvent(payload)),
    updateEvent: (payload) => dispatch(updateEventsRequest(payload)),
    eventGoing: (payload) => dispatch(eventGoing(payload)),
    eventNotGoing: (payload) => dispatch(eventNotGoing(payload)),
    toggleLike: (payload) => dispatch(toggleLikeRequest(payload)),
    toggleCommentLike: (payload) => dispatch(toggleCommentLikeRequest(payload)),
    getFeedItemDetails: (payload) => dispatch(getFeedItemDetailsRequest(payload)),
    postComment: (payload) => dispatch(postCommentRequest(payload)),
    populatePostReportTypes: () => dispatch(populatePostReportTypesRequest()),
    resetSingleEventById: () =>
      dispatch({
        type: RESET_EVENT_BY_ID_SUCCESS,
        payload: '',
      }),
  };

  return <EventDetails {...props} {...state} {...actions} />;
};

export default EventDetailsContainer;
